import React from 'react';
import { observer } from 'mobx-react';
import { charactersStore } from 'stores';

interface CharactersListProps {
    dynamic?: boolean;
    onCreateCharacter?: () => void;
    onCharacterSelect?: (characterId: number) => void; // ✅ добавляем сюда
}

const CharactersList: React.FC<CharactersListProps> = ({ onCreateCharacter, onCharacterSelect }) => {
    const handleSelect = (charId: number) => {
        charactersStore.selectCharacter(charId);
        if (onCharacterSelect) {
            onCharacterSelect(charId); // вызываем переданный колбэк
        }
    };

    const filteredCharacters = charactersStore.characters;

    const getCoverImage = (char: typeof filteredCharacters[0]) => {
        let cover = char.image
            ? char.image.endsWith('.jpg')
                ? char.image.replace(/\.jpg$/, '.png')
                : char.image
            : `/images/cover_${char.race}_${char.charClass}_${char.gender}.png`;

        if (!cover.startsWith('/')) cover = `/images/${cover}`;
        return cover;
    };

    const getPortraitImage = (char: typeof filteredCharacters[0]) => {
        let portrait = char.portrait || char.image || '/images/no-portrait.png';
        if (!portrait.startsWith('/')) portrait = `/images/${portrait}.png`;
        return portrait;
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div style={{ display: 'flex', gap: 16, overflowX: 'auto', paddingBottom: 8 }}>
                {filteredCharacters.length === 0 && <p>Персонажи не найдены</p>}

                {filteredCharacters.map((char) => {
                    const isSelected = charactersStore.selectedCharacter?.id === char.id;

                    return (
                        <div
                            key={char.id}
                            onClick={() => handleSelect(char.id)}
                            style={{
                                width: 200,
                                height: 300,
                                perspective: '1000px',
                                cursor: 'pointer',
                                flex: '0 0 auto',
                            }}
                        >
                            <div
                                style={{
                                    position: 'relative',
                                    width: '100%',
                                    height: '100%',
                                    textAlign: 'center',
                                    transition: 'transform 0.6s',
                                    transformStyle: 'preserve-3d',
                                    transform: isSelected ? 'rotateY(180deg)' : 'rotateY(0deg)',
                                }}
                            >
                                {/* Front (обложка) */}
                                <div
                                    style={{
                                        position: 'absolute',
                                        width: '100%',
                                        height: '100%',
                                        backfaceVisibility: 'hidden',
                                        borderRadius: 8,
                                        overflow: 'hidden',
                                        border: '1px solid #ccc',
                                    }}
                                >
                                    <img
                                        src={getCoverImage(char)}
                                        alt={`${char.name}-cover`}
                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                    />
                                </div>

                                {/* Back (портрет + инфо) */}
                                <div
                                    style={{
                                        position: 'absolute',
                                        width: '100%',
                                        height: '100%',
                                        backfaceVisibility: 'hidden',
                                        transform: 'rotateY(180deg)',
                                        borderRadius: 8,
                                        border: '2px solid #00aaff',
                                        backgroundColor: '#f5f5f5',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'flex-start',
                                        padding: 0,
                                    }}
                                >
                                    <img
                                        src={getPortraitImage(char)}
                                        alt={char.name}
                                        style={{
                                            width: 200,
                                            height: 200,
                                            objectFit: 'cover',
                                            borderRadius: 4,
                                            marginBottom: 0,
                                        }}
                                    />
                                    <div
                                        style={{
                                            width: '100%',
                                            backgroundColor: '#001b39',
                                            textAlign: 'center',
                                            padding: '0px 0',
                                            borderRadius: '0 0 0px 0px',
                                            color: '#fff',
                                        }}
                                    >
                                        <div style={{ fontWeight: 'bold', fontSize: 12 }}>{char.name}</div>
                                        <div style={{ fontSize: 11 }}>Уровень: {char.level ?? 'N/A'}</div>
                                        <div style={{ fontSize: 11 }}>Класс: {char.charClass ?? 'N/A'}</div>
                                        <div style={{ fontSize: 11 }}>Раса: {char.race ?? 'N/A'}</div>
                                        <div style={{ fontSize: 11 }}>Пол: {char.gender ?? 'N/A'}</div>
                                        <div style={{ fontSize: 11 }}>Гильдия: {char.guild || 'Без гильдии'}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>

            {onCreateCharacter && (
                <button
                    onClick={onCreateCharacter}
                    style={{
                        marginTop: 16,
                        padding: '12px 0',
                        border: 'none',
                        borderRadius: 8,
                        backgroundColor: '#00aaff',
                        color: '#fff',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        fontSize: 14,
                        width: 300,
                    }}
                >
                    Создать нового персонажа
                </button>
            )}
        </div>
    );
};

export default observer(CharactersList);
